import { CALL_API_METHODS } from "repoV2/constants/apis";
import { callApi } from "repoV2/utils/common/api/callApi";
import { logError } from "repoV2/utils/common/error/error";
import { BRANDED_COMMUNITY_API_URLS } from "../../constants/brandedCommunity.api";

export const callGetBonusOfferings = async ({
    community_listing_id,
    page,
    isJwtFlagEnabled = false,
}: {
    community_listing_id: string | undefined;
    page?: number;
    isJwtFlagEnabled?: boolean;
}): Promise<any> => {
    try {
        const response = await callApi({
            url: BRANDED_COMMUNITY_API_URLS.GET_COMMUNITY_OFFERINGS,
            params: {
                community_listing_id,
                page,
            },
            extraOptions: {
                appendAuthHeaders: true,
                appendTimezoneHeaders: true,
                appendExlyOriginHeaders: true,
                ...(isJwtFlagEnabled && { appendJwtTokenHeaders: true }),
            },
        });
        const {
            data: {
                data: {
                    bonus_offerings: offerings = [],
                    total,
                    total_pages: totalPages,
                },
            },
        } = response;

        return {
            offerings,
            total,
            totalPages,
        };
    } catch (err) {
        logError({
            error: err,
            occuredAt: " pages/brandedCommunity/index",
            when: "calling callApiforBonusOfferings",
        });
        throw err;
    }
};

export const callGetGroups = async ({
    communityListingUuid,
}: {
    communityListingUuid: string;
}) => {
    try {
        const response = await callApi({
            url: BRANDED_COMMUNITY_API_URLS.GET_GROUPS,
            method: CALL_API_METHODS.GET,
            params: { community_listing_uuid: communityListingUuid },
            extraOptions: { appendExlyBackendHeaders: true },
        });
        return response.data.data.community_groups;
    } catch (error) {
        logError({
            error,
            occuredAt: " pages/brandedCommunity/Index",
            when: "calling callGetGroups",
        });
        throw error;
    }
};

export const callCreateProfile = async ({
    communityListingUuid,
    description,
    profilePic,
}: {
    communityListingUuid: string;
    profilePic: string;
    description: string;
}) => {
    try {
        const response = await callApi({
            url: BRANDED_COMMUNITY_API_URLS.CREATE_CUSTOMER_PROFILE,
            method: CALL_API_METHODS.POST,
            data: {
                listing_uuid: communityListingUuid,
                profile_pic: profilePic,
                description,
            },
            extraOptions: {
                appendAuthHeaders: true,
                appendTimezoneHeaders: true,
                appendExlyOriginHeaders: true,
                appendJwtTokenHeaders: true,
            },
        });
        return response.data.data.profile_uuid;
    } catch (error) {
        logError({
            error,
            occuredAt: " pages/brandedCommunity/Index",
            when: "calling callCreateProfile",
        });
        throw error;
    }
};

export const callGetCommunityProfile = async ({
    communityListingUuid,
    customerUsername,
}: {
    communityListingUuid: string;
    customerUsername: string;
}) => {
    try {
        const response = await callApi({
            url: BRANDED_COMMUNITY_API_URLS.GET_COMMUNITY_PROFILE,
            method: CALL_API_METHODS.GET,
            params: {
                community_listing_uuid: communityListingUuid,
                username: customerUsername,
            },
            extraOptions: {
                appendAuthHeaders: true,
                appendTimezoneHeaders: true,
                appendExlyOriginHeaders: true,
                appendJwtTokenHeaders: true,
            },
        });

        return response.data.data;
    } catch (error) {
        logError({
            error,
            occuredAt: " pages/brandedCommunity/Index",
            when: "calling callGetOnlineCustomer",
        });
        throw error;
    }
};

export const callUpdateCustomerProfile = async ({
    communityListingUuid,
    description,
    profilePic,
    profileUuid,
}: {
    communityListingUuid: string;
    profileUuid: string;
    profilePic?: string;
    description?: string;
}) => {
    try {
        const response = await callApi({
            url: BRANDED_COMMUNITY_API_URLS.UPDATE_CUSTOMER_PROFILE,
            method: CALL_API_METHODS.POST,
            data: {
                community_listing_uuid: communityListingUuid,
                profile_uuid: profileUuid,
                updated_values: {
                    profile_pic: profilePic,
                    description,
                },
            },
            extraOptions: {
                appendAuthHeaders: true,
                appendTimezoneHeaders: true,
                appendExlyOriginHeaders: true,
                appendJwtTokenHeaders: true,
            },
        });

        return response.data.data;
    } catch (error) {
        logError({
            error,
            occuredAt: " pages/brandedCommunity/Index",
            when: "calling callGetOnlineCustomer",
        });
        throw error;
    }
};

export const callGetHostProfile = async ({
    hostName,
}: {
    hostName: string;
}) => {
    try {
        const response = await callApi({
            url: BRANDED_COMMUNITY_API_URLS.GET_HOST_PROFILE(hostName),
            method: CALL_API_METHODS.GET,
            extraOptions: {
                appendAuthHeaders: true,
                appendExlyOriginHeaders: true,
            },
        });

        return response.data.data.profile_data;
    } catch (error) {
        logError({
            error,
            occuredAt: " pages/brandedCommunity/Index",
            when: "calling callGetHostdata",
        });
        throw error;
    }
};
